import DataTable from "../../../Components/DataTable/DataTable";
import { PercentageOutlined } from "@ant-design/icons";
import { useEffect, useRef, useState } from "react";
import * as actions from "../../../store/actions/action";
import api from "../../../api/api";
import { connect } from "react-redux";
import { Button, Input, Modal, Tag } from "antd";
import CheckPermission from "../../../Util/CheckPermission";
import { useNavigate } from "react-router-dom";
import { editError } from "../../../Util/Messages";
import ExportExcel from "../../../Util/ExportExcel";
import { toJalaali } from "jalaali-js";
import DatePicker from "react-multi-date-picker";
import persian_fa from "react-date-object/locales/persian_fa";
import jalali from "react-date-object/calendars/jalali";
import TextEditor from "../../../Components/TextEditor/TextEditor";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";

const MAX_TEXT_LEN_IN_TABLE = 15;

const ExternalDiscount = ({
  rowSelection,
  LoadingSetter,
  ClearLoading,
  loading,
  ClearError,
  ErrorSetter,
  permissions,
}) => {
  const [data, setData] = useState();
  const [moreModal, setMoreModal] = useState(false);
  const [modalData, setModalData] = useState();

  const [totalValid, setTotalValid] = useState();
  const [userValid, setUserValid] = useState();

  const navigate = useNavigate();

  const columns = [
    // title
    {
      title: "نام",
      dataIndex: "title",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return <Input.TextArea autoSize />;
        }
      },
    },
    // subLine
    {
      title: "ساب لاین تگ",
      dataIndex: "subLine",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input.TextArea autoSize />;
      },
      render: (_, record) => {
        if (typeof record.subLine !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.subLine?.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.subLine.substring(0, MAX_TEXT_LEN_IN_TABLE)}...`
          : record.subLine;
      },
    },
    // discountCode
    {
      title: "کد تخفیف روش یادگیری",
      dataIndex: "discountCode",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input.TextArea autoSize />;
      },
    },
    // percentage
    {
      title: "درصد تخفیف",
      dataIndex: "percentage",
      searchable: true,
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input autoSize type="number" />;
      },
    },
    // max amount
    {
      title: "حداکثر تخفیف",
      dataIndex: "maxAmount",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input autoSize type="number" />;
      },
      render: (_, row) => {
        if (typeof row.maxAmount !== "number") {
          return <Tag color="red">ندارد</Tag>;
        }

        return `${row.maxAmount.toLocaleString()} تومان`;
      },
    },
    // count
    {
      title: "تعداد",
      dataIndex: "count",
      sorter: (a, b) => {
        const Adate = a.count ?? 10 ** 5;
        const Bdate = b.count ?? 10 ** 5;
        return Bdate - Adate;
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) return <Input autoSize type="number" />;
      },
      render: (_, record) => {
        if (typeof record.count !== "number") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.count.toLocaleString();
      },
    },
    // logo link
    {
      title: "لینک لوگو",
      dataIndex: "logoLink",
      filters: [
        { text: "دارد", value: true },
        { text: "ندارد", value: false },
      ],
      onFilter: (val, record) => (record.logoLink ? true : false === val),
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Button
              size="small"
              onClick={() => {
                setModalData((prev) =>
                  prev?.id === record.id ? prev : record
                );
                setMoreModal(true);
              }}
            >
              تغییرات
            </Button>
          );
          if (!record.logoLink || typeof record.logoLink !== "string") {
            return (
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                <Tag color="red">ندارد</Tag>
              </div>
            );
          }

          return (
            <>
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                <Tag color="green">دارد</Tag>
              </div>
            </>
          );
        }
      },
      render: (_, record) => {
        if (typeof record.logoLink !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }
        return <Tag color="green">دارد</Tag>;
      },
    },
    // usageDescription
    {
      title: "توضیحات استفاده",
      dataIndex: "usageDescription",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Button
              size="small"
              onClick={() => {
                setModalData((prev) =>
                  prev?.id === record.id ? prev : record
                );
                setMoreModal(true);
              }}
            >
              تغییرات
            </Button>
          );
          if (
            !record.usageDescription ||
            typeof record.usageDescription !== "string"
          ) {
            return (
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                <Tag color="red">ندارد</Tag>
              </div>
            );
          }

          return (
            <>
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                {record.usageDescription?.length > MAX_TEXT_LEN_IN_TABLE
                  ? `${record.usageDescription.substring(
                      0,
                      MAX_TEXT_LEN_IN_TABLE
                    )}...`
                  : record.usageDescription}
              </div>
            </>
          );
        }
      },
      render: (_, record) => {
        if (typeof record.usageDescription !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.usageDescription?.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.usageDescription.replace(
              /<\/?[^>]+(>|$)/g,
              " "
            )}...`.substring(0, MAX_TEXT_LEN_IN_TABLE)
          : record.usageDescription.replace(/<\/?[^>]+(>|$)/g, " ");
      },
    },
    // overallDescription
    {
      title: "توضیحات بیزینس",
      dataIndex: "overallDescription",
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <Button
              size="small"
              onClick={() => {
                setModalData((prev) =>
                  prev?.id === record.id ? prev : record
                );
                setMoreModal(true);
              }}
            >
              تغییرات
            </Button>
          );
          if (
            !record.overallDescription ||
            typeof record.overallDescription !== "string"
          ) {
            return (
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                <Tag color="red">ندارد</Tag>
              </div>
            );
          }

          return (
            <>
              <div
                style={{
                  gap: "0.2rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Button
                  size="small"
                  onClick={() => {
                    setModalData(record);
                    setMoreModal(true);
                  }}
                >
                  تغییرات
                </Button>
                {record.overallDescription?.length > MAX_TEXT_LEN_IN_TABLE
                  ? `${record.overallDescription.substring(
                      0,
                      MAX_TEXT_LEN_IN_TABLE
                    )}...`
                  : record.overallDescription}
              </div>
            </>
          );
        }
      },
      render: (_, record) => {
        if (typeof record.overallDescription !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        return record.overallDescription?.length > MAX_TEXT_LEN_IN_TABLE
          ? `${record.overallDescription?.replace(
              /<\/?[^>]+(>|$)/g,
              " "
            )}...`.substring(0, MAX_TEXT_LEN_IN_TABLE)
          : record?.overallDescription?.replace(/<\/?[^>]+(>|$)/g, " ");
      },
    },
    // validUntil
    {
      title: "اعتبار",
      align: "center",
      dataIndex: "validUntil",
      sorter: (a, b) => {
        try {
          const Adate = new Date(a.validUntil);
          const Bdate = new Date(b.validUntil);
          return Bdate - Adate;
        } catch (error) {
          return 0;
        }
      },
      render: (ـ, record) => {
        if (typeof record.validUntil !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        const date = new Date(record.validUntil);

        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <DatePicker
              format="YYYY/MM/DD"
              calendar={jalali}
              locale={persian_fa}
              render={(value, openCalendar) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    {record.id !== totalValid && (
                      <Input value={value} onClick={openCalendar} />
                    )}

                    {record.id !== totalValid ? (
                      <ClearIcon
                        onClick={() => setTotalValid(record.id)}
                        fontSize="small"
                      />
                    ) : (
                      <AddIcon
                        onClick={() => setTotalValid()}
                        fontSize="small"
                      />
                    )}
                  </div>
                );
              }}
            />
          );
        }
      },
    },
    // validUntilForUser
    {
      title: "اعتبار برای کاربر",
      align: "center",
      dataIndex: "validUntilForUser",
      sorter: (a, b) => {
        try {
          const Adate = new Date(a.validUntilForUser);
          const Bdate = new Date(b.validUntilForUser);
          return Bdate - Adate;
        } catch (error) {
          return 0;
        }
      },
      render: (ـ, record) => {
        if (typeof record.validUntilForUser !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }

        const date = new Date(record.validUntilForUser);

        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
      renderFormItem: (_, { isEditable, record }) => {
        if (isEditable) {
          return (
            <DatePicker
              format="YYYY/MM/DD"
              calendar={jalali}
              locale={persian_fa}
              render={(value, openCalendar) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    {record.id !== userValid && (
                      <Input value={value} onClick={openCalendar} />
                    )}

                    {record.id !== userValid ? (
                      <ClearIcon
                        onClick={() => setUserValid(record.id)}
                        fontSize="small"
                      />
                    ) : (
                      <AddIcon
                        onClick={() => setUserValid()}
                        fontSize="small"
                      />
                    )}
                  </div>
                );
              }}
            />
          );
        }
      },
    },
    // created at
    {
      title: "تاریخ ساخت ",
      align: "center",
      dataIndex: "createdAt",
      editable: false,
      sorter: (a, b) => {
        const Adate = new Date(a.createdAt);
        const Bdate = new Date(b.createdAt);

        return Bdate - Adate;
      },
      render: (_, record) => {
        if (typeof record.createdAt !== "string") {
          return <Tag color="red">ندارد</Tag>;
        }
        const date = record.createdAt ? new Date(record.createdAt) : new Date();
        const jalali = toJalaali(
          date.getFullYear(),
          date.getMonth() + 1,
          date.getDate()
        );
        return (
          <span dir="ltr">
            {jalali.jy}-{jalali.jm}-{jalali.jd}{" "}
            {date.toLocaleTimeString("eo", { hour12: false })}
          </span>
        );
      },
    },
  ];

  useEffect(() => {
    if (
      permissions !== null &&
      CheckPermission("external_discount_list", permissions) === false
    ) {
      navigate("/permissionDenied");
    }
  }, [permissions]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    LoadingSetter();
    api
      .get("/external-discount")
      .then((res) => {
        setData(res.data);
      })
      .finally(() => ClearLoading());
  };
  const exportData = () => {};

  const onSave = (row, rowData) => {
    LoadingSetter();

    let oldData = null;
    data.forEach((item) => {
      if (item.id === row.id) oldData = item;
    });

    if (oldData === null) {
      api
        .post("/external-discount", {
          ...rowData,
          name: rowData.title,
          count: rowData.count ? +rowData.count : undefined,
          percentage: rowData.percentage ? +rowData.percentage : undefined,
          maxAmount: rowData.maxAmount ? +rowData.maxAmount : undefined,
          validUntil: rowData?.validUntil?.toDate(),
          validUntilForUser: rowData?.validUntilForUser?.toDate(),
          logoLink: modalData?.logoLink,
          usageDescription: modalData?.usageDescription,
          overallDescription: modalData?.overallDescription,
        })
        .then(() => {
          ClearLoading();
          loadData();
        })
        .catch(() => {
          ClearLoading();
          editError();
        });
    } else {
      api
        .put("/external-discount/" + oldData.id, {
          subLine: rowData?.subLine,
          discountCode: rowData?.discountCode,
          name: rowData.title,
          count: rowData.count ? +rowData.count : undefined,
          percentage: rowData.percentage ? +rowData.percentage : undefined,
          maxAmount: rowData.maxAmount ? +rowData.maxAmount : undefined,

          ...(totalValid !== oldData.id
            ? {
                validUntil:
                  typeof rowData?.validUntil === "string"
                    ? rowData?.validUntil
                    : rowData?.validUntil?.toDate(),
              }
            : {}),

          ...(userValid !== oldData.id
            ? {
                validUntilForUser:
                  typeof rowData?.validUntilForUser === "string"
                    ? rowData?.validUntilForUser
                    : rowData?.validUntilForUser?.toDate(),
              }
            : {}),

          logoLink:
            modalData?.id === oldData.id
              ? modalData?.logoLink
              : rowData?.logoLink,

          usageDescription:
            modalData?.id === oldData.id
              ? modalData?.usageDescription
              : rowData?.usageDescription,

          overallDescription:
            modalData?.id === oldData.id
              ? modalData?.overallDescription
              : rowData?.overallDescription,
        })
        .then((res) => {
          // console.log(res.data);
          ClearLoading();
        })
        .catch(() => {
          ClearLoading();
          editError();
        })
        .finally(() => loadData());
    }
  };
  // const exportData = () => {
  //   const json = waysData.map((way) => {
  //     const wayObj = {
  //       نوع: WayMapper[way.type].title,
  //       "نام روش یادگیری": way.title,
  //       توضیحات: way.description,
  //     };
  //     way.skills.forEach((skill, index) => {
  //       wayObj[`مهارت متصل ${index + 1}`] = skill.title;
  //     });
  //     if (Array.isArray(way.links)) {
  //       way.links.forEach((link, index) => {
  //         wayObj[`لینک ${index + 1}`] = link;
  //       });
  //     }

  //     return wayObj;
  //   });
  //   ExportExcel(json, "روش‌های یادگیری");
  // };

  return (
    <div>
      <DataTable
        tableKey="external-discount"
        header={{
          title: "کدهای تخفیف",
          avatar: { icon: <PercentageOutlined />, size: "large" },
          // extra: CheckPermission("export_excel", permissions) && (
          //   <Button onClick={exportData}>خروجی اکسل</Button>
          // ),
        }}
        editable
        keepPageOnSave
        hideComment
        hideErrorReport
        path="/external-discount"
        columns={columns}
        dataSource={data}
        setDataSource={setData}
        onSave={onSave}
        reload={loadData}
        permissionsPrefix="external_discount"
        recordDefault={{}}
        // rowSelection={rowSelection}
        // editableKeys={editableKeys}
        // setEditableRowKeys={setEditableRowKeys}
      />
      <Modal
        // destroyOnClose
        centered
        fullSize
        width={800}
        open={moreModal}
        onOk={() => setMoreModal(false)}
        onCancel={() => setMoreModal(false)}
      >
        <h3>لینک لوگو</h3>
        <Input
          autoSize
          value={modalData?.logoLink ? modalData?.logoLink : ""}
          onChange={(a) =>
            setModalData((prev) => ({
              ...prev,
              logoLink: a.target.value,
            }))
          }
        />

        <hr style={{ marginTop: "2rem", marginBottom: "2rem" }}></hr>

        <h3>نحوه استفاده</h3>
        <TextEditor
          value={modalData?.usageDescription ?? ""}
          onChange={(val) =>
            setModalData((prev) => ({ ...prev, usageDescription: val }))
          }
        />
        <hr style={{ marginTop: "2rem", marginBottom: "2rem" }}></hr>

        <h3>توضیحات بیزینس</h3>
        <TextEditor
          value={modalData?.overallDescription ?? ""}
          onChange={(val) =>
            setModalData((prev) => ({ ...prev, overallDescription: val }))
          }
        />
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    loading: state.loading,
    error: state.error,
    permissions: state.userData ? state.userData.permissions : null,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearError: () => dispatch(actions.ClearError()),
    ClearLoading: () => dispatch(actions.ClearLoading()),
    LoadingSetter: () => dispatch(actions.LoadingSetter()),
    ErrorSetter: () => dispatch(actions.ErrorSetter()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ExternalDiscount);
